import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { fadeUp } from "@/utils/animations";

const ARTICLES = [
  {
    slug: "pvc-warehouse-dividing-walls-complete-guide",
    title: "PVC Warehouse Dividing Walls: The Complete Guide for Australian Businesses",
    excerpt: "Everything you need to know about PVC warehouse partition walls — materials, installation, costs, and how they compare to permanent construction.",
    category: "Buying Guide",
    readTime: "8 min read",
    date: "2026-01-15",
  },
  {
    slug: "industrial-sliding-curtains-how-they-work",
    title: "Industrial Sliding Curtains: How They Work, Where They're Used, and What to Look For",
    excerpt: "A practical guide to industrial sliding curtain systems — track types, materials, applications, and selection criteria for Australian facilities.",
    category: "Product Education",
    readTime: "7 min read",
    date: "2026-01-22",
  },
  {
    slug: "welding-curtains-australian-standards",
    title: "Welding Curtains and Screens: Australian Standards and What Your Workshop Needs",
    excerpt: "Understanding the safety requirements for welding curtains in Australian workshops, including UV ratings, flame retardancy, and compliance.",
    category: "Safety & Compliance",
    readTime: "6 min read",
    date: "2026-01-29",
  },
  {
    slug: "how-to-control-warehouse-dust",
    title: "How to Control Dust in Your Warehouse Without Permanent Construction",
    excerpt: "Practical dust containment solutions using PVC walls and curtains that install in days, don't need permits, and actually work.",
    category: "Problem-Solution",
    readTime: "5 min read",
    date: "2026-02-05",
  },
  {
    slug: "5-ways-industrial-curtains-save-money",
    title: "5 Ways Industrial Curtains Save Manufacturing Businesses Money",
    excerpt: "From energy savings to reduced downtime — here's how industrial curtains deliver ROI for Australian manufacturers.",
    category: "Business Case",
    readTime: "5 min read",
    date: "2026-02-12",
  },
  {
    slug: "warehouse-energy-costs-curtain-walls",
    title: "Why Your Warehouse is Wasting Energy — And How Curtain Walls Fix It",
    excerpt: "Temperature control curtains can reduce warehouse energy costs by up to 30%. Here's how they work and what it means for your bottom line.",
    category: "Problem-Solution",
    readTime: "6 min read",
    date: "2026-02-19",
  },
];

export const BLOG_ARTICLES = ARTICLES;

export default function BlogPage() {
  return (
    <div data-testid="blog-page" className="min-h-screen bg-[#0A0A0A]">
      <section className="pt-28 pb-8 sm:pt-36 bg-[#141414]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="industrial-line mb-6" />
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
            Insights & <span className="gradient-text">Resources</span>
          </h1>
          <p className="text-base text-[#A3A3A3] max-w-xl">
            Expert guides, industry insights, and practical advice for Australian industrial facility managers.
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#0A0A0A]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {ARTICLES.map((article, i) => (
              <motion.div
                key={article.slug}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
                custom={i}
              >
                <Link
                  to={`/blog/${article.slug}`}
                  className="block bg-[#141414] border border-[#2E2E2E] p-6 hover:border-[#FF5722] transition-all duration-300 h-full group"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-[#FF5722] text-[10px] font-bold uppercase tracking-wider">{article.category}</span>
                    <span className="text-[#666] text-[10px] flex items-center gap-1"><Clock size={10} />{article.readTime}</span>
                  </div>
                  <h2 className="text-base font-bold mb-2 group-hover:text-[#FF5722] transition-colors leading-snug" style={{ fontFamily: "'Clash Display', sans-serif" }}>
                    {article.title}
                  </h2>
                  <p className="text-sm text-[#A3A3A3] mb-4 line-clamp-2">{article.excerpt}</p>
                  <span className="text-[#FF5722] text-xs font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read More <ArrowRight size={12} />
                  </span>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
